import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBell2Off: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBell2Off"><Path d="M20.5 17V16.25L18.9062 13L18.6934 8.82543C18.515 5.28203 15.5712 2.5 12 2.5C10.3964 2.5 8.91921 3.06099 7.76218 4M6.0987 6C5.63912 6.84633 5.35804 7.80427 5.30665 8.82543L5.09375 13L3.5 16.25V17.5H17.5" stroke="currentColor"/><Path d="M8.00659 17.7322C8.12687 19.8332 9.86878 21.4999 12 21.4999C14.1311 21.4999 15.8731 19.8332 15.9933 17.7322" stroke="currentColor"/><Path d="M2.5 2.5L21.5 21.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconBell2Off;
